import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useEffectOnce } from 'usehooks-ts';

import { orderTemplatesFetch } from './action';
import { selectFeatureOrderTemplate } from './selector';

export const useOrderTemplatesFetch = () => {
  const dispatch = useDispatch();
  const { orderTemplates } = useSelector(selectFeatureOrderTemplate);

  useEffectOnce(() => {
    if (!isEmpty(orderTemplates)) return;
    dispatch(orderTemplatesFetch());
  });

  return orderTemplates;
};
